import {List} from 'immutable';

export default function (modelState) {
  const validationErrors = new List().asMutable();
  modelState.forEach(fieldErrors => fieldErrors.forEach(error => validationErrors.push(error)));
  return validationErrors.asImmutable();
}



// WEBPACK FOOTER //
// ./app/features/shared/services/getValidationErrorsFromModelState.js